import { MachineAttribute } from '@internal/utils/machine/MachineAttribute'
import {
  MachineSubType,
  MachineType,
} from '@internal/utils/machine/MachineType'
import { TFilterableBaleChamberOption } from '@internal/utils/search/TFilterableBalerChamberOption'
import { TFilterableHeaderTypeOption } from '@internal/utils/search/TFilterableHeaderTypeOption'
import { SearchResultsSortKey } from './SearchResultsSortKey'
import { TRangeFiltersMap } from './TRangeFiltersMap'

export type SearchModel = {
  name: string
  type: 'fuzzy' | 'mapped' | 'base' | 'series'
}

export const mappedModelSuffix = '-mapped'

export type TSearchParams = {
  models: SearchModel[]
  brands: string[]
  machineType: MachineType | undefined
  machineSubType: MachineSubType | undefined
  baleChamber: TFilterableBaleChamberOption | undefined
  headerType: TFilterableHeaderTypeOption | undefined
  amount: number
  features: MachineAttribute[]
  rangeFilters: TRangeFiltersMap
  locations: string[]
  sort: SearchResultsSortKey
}
